const Branches ={
  "universityName": "GGSIPU",
  "courses": [
    {
      "courseName": "Btech",
      "branches": [
        {
          "branchName": "CSE",
          "years": [
            {
              "year": "1st",
              "subjects": [
                {
                  "subjectName": "Maths",
                  "Note": [
                    {
                      "title": "Note 1",
                      "noteLink": "https://youtube.com"
                    },
                    {
                      "title": "Note 2",
                      "noteLink": "https://youtube.com"
                    },
                    {
                      "title": "Note 3",
                      "noteLink": "https://youtube.com"
                    }
                  ],
                  "youtubeLink": {
                    "title": "Maths Tutorial",
                    "link": "https://youtube.com/maths-tutorial"
                  },
                  "PYQ": {
                    "title": "Maths Previous Year Questions",
                    "link": "https://link-to-maths-pyq"
                  },
                  "syllabus": {
                    "title": "Maths Syllabus",
                    "link": "https://link-to-maths-syllabus"
                  }
                },
                
                {
                  "subjectName": "Chemistry",
                  "notesPage": "https://link-to-chemistry-notes",
                  "youtubeLink": "https://youtube.com/chemistry-tutorial",
                  "PYQ": "https://link-to-chemistry-pyq",
                  "syllabus": "https://link-to-chemistry-syllabus"
                },
                {
                  "subjectName": "Workshop",
                  "notesPage": "https://link-to-workshop-notes",
                  "youtubeLink": "https://youtube.com/workshop-tutorial",
                  "PYQ": "https://link-to-workshop-pyq",
                  "syllabus": "https://link-to-workshop-syllabus"
                }
              ]
            },
            {
              "year": "2nd",
              "subjects": [
                {
                  "subjectName": "Maths-II",
                  "notesPage": "https://link-to-maths-ii-notes",
                  "youtubeLink": "https://youtube.com/maths-ii-tutorial",
                  "PYQ": "https://link-to-maths-ii-pyq",
                  "syllabus": "https://link-to-maths-ii-syllabus"
                },
                {
                  "subjectName": "Electronics",
                  "notesPage": "https://link-to-electronics-notes",
                  "youtubeLink": "https://youtube.com/electronics-tutorial",
                  "PYQ": "https://link-to-electronics-pyq",
                  "syllabus": "https://link-to-electronics-syllabus"
                },
                {
                  "subjectName": "Computer Programming",
                  "notesPage": "https://link-to-computer-programming-notes",
                  "youtubeLink": "https://youtube.com/computer-programming-tutorial",
                  "PYQ": "https://link-to-computer-programming-pyq",
                  "syllabus": "https://link-to-computer-programming-syllabus"
                }
              ]
            },
            {
              "year": "3rd",
              "subjects": [
                {
                  "subjectName": "Data Structures",
                  "notesPage": "https://link-to-data-structures-notes",
                  "youtubeLink": "https://youtube.com/data-structures-tutorial",
                  "PYQ": "https://link-to-data-structures-pyq",
                  "syllabus": "https://link-to-data-structures-syllabus"
                },
                {
                  "subjectName": "Operating Systems",
                  "notesPage": "https://link-to-operating-systems-notes",
                  "youtubeLink": "https://youtube.com/operating-systems-tutorial",
                  "PYQ": "https://link-to-operating-systems-pyq",
                  "syllabus": "https://link-to-operating-systems-syllabus"
                },
                {
                  "subjectName": "DBMS",
                  "notesPage": "https://link-to-dbms-notes",
                  "youtubeLink": "https://youtube.com/dbms-tutorial",
                  "PYQ": "https://link-to-dbms-pyq",
                  "syllabus": "https://link-to-dbms-syllabus"
                }
              ]
            },
            {
              "year": "4th",
              "subjects": [
                {
                  "subjectName": "Data Structures",
                  "notesPage": "https://link-to-data-structures-notes-4th",
                  "youtubeLink": "https://youtube.com/data-structures-tutorial-4th",
                  "PYQ": "https://link-to-data-structures-pyq-4th",
                  "syllabus": "https://link-to-data-structures-syllabus-4th"
                },
                {
                  "subjectName": "Operating Systems",
                  "notesPage": "https://link-to-operating-systems-notes-4th",
                  "youtubeLink": "https://youtube.com/operating-systems-tutorial-4th",
                  "PYQ": "https://link-to-operating-systems-pyq-4th",
                  "syllabus": "https://link-to-operating-systems-syllabus-4th"
                },
                {
                  "subjectName": "DBMS",
                  "notesPage": "https://link-to-dbms-notes-4th",
                  "youtubeLink": "https://youtube.com/dbms-tutorial-4th",
                  "PYQ": "https://link-to-dbms-pyq-4th",
                  "syllabus": "https://link-to-dbms-syllabus-4th"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}



export default Branches;